import {Injectable} from '@angular/core'
import {DataService} from '@service/data.service'

/**
 * Variante de `DataService` para el modo embebido.
 *
 * @description
 * Extiende `DataService` anulando los canales de cambios locales y remotos, dado que en
 * modo embebido la sincronización la coordina la aplicación anfitriona. La app sigue
 * teniendo acceso a las instancias PouchDB (para consultas en memoria), pero no emite
 * señales de cambio ni las recibe desde Firestore.
 *
 * @usageNotes
 *
 * ### Bad Uses / Errores comunes
 * - Usar métodos que dependan de `unsynchronizedChanges` en este modo: la propiedad es
 *   `null` y cualquier suscripción directa fallará.
 */
@Injectable({
  providedIn: 'root',
})
export class DataEmbeddedService extends DataService {
  unsynchronizedChanges = null
  firestoreChanges = null
  firestoreChangesRemote = null
}
